export const PROPERTY_BOOK = 'property_book';
export const PROPERTY_BOOK_V2 = 'property_book_v2';

export const INTERACTIVE_MAP_ADDRESS_PIN_CLICK = 'interactive_map_address_pin_click';
export const INTERACTIVE_MAP_PROPERTY_PIN_CLICK = 'interactive_map_property_pin_click';
export const TRACK_CSL = '_csl';
export const TRACK_ACTIVE = '_active';
export const TRACK_ARCHIVED = '_archived';
export const EXPLORE_PRICETABLE_LINKS = 'explore_pricetable_links';
export const INTERACTIVE_MAP_NEXT_ARROW_CLICK = 'interactive_map_next_arrow_click';
export const INTERACTIVE_MAP_PREVIOUS_ARROW_CLICK = 'interactive_map_previous_arrow_click';
export const INTERACTIVE_ATLAS_NAVI_COLLAPSE = 'interactive_atlas_navi_collapse';
export const INTERACTIVE_ATLAS_NAVI_EXPAND = 'interactive_atlas_navi_expand';
export const INTERACTIVE_MAP_EXPOSE_LINK = 'interactive_map_expose_link';
export const INTERACTIVE_MAP_REALTOR_LINK = 'interactive_map_realtor_link';
export const SEARCH_SELECT_ADDRESS = 'search_select_address';
export const SEARCH_ENTER_ADDRESS = 'search_enter_address';
export const SEARCH_CLICK_ON_SEARCH_FIELD = 'search_click_on_search_field';
export const LISTINGS_ACTION_VISIT_ADDRESS = 'listings_action_visit_address';
export const LISTINGS_ACTION_VIEW_ACTIONS = 'listings_action_view_actions';
export const LISTINGS_ACTION_VIEW_ADDRESS = 'listings_action_view_address';
export const LISTINGS_ACTION_VIEW_AGENT = 'listings_action_view_agent';
export const LISTINGS_ACTION_VIEW_EXPOSE = 'listings_action_view_expose';
export const LISTINGS_ACTION_VIEW_LISTINGS_DETAILS = 'listings_action_view_listings_details';
export const LISTINGS_WIDGET_ACTION_VIEW_EXPOSE = 'dashboard_listings_address_click';
export const DASHBOARD_BUTTON_LISTINGS = 'dashboard_button_listings';
export const DASHBOARD_LISTINGS_OPEN = 'dashboard_listings_open';
export const REAL_ESTATE_TYPE_WOHNUNG = 'real_estate_type_wohnung';
export const REAL_ESTATE_TYPE_HAUS = 'real_estate_type_haus';
export const REAL_ESTATE_TYPE_MIETEN = 'real_estate_type_mieten';
export const REAL_ESTATE_TYPE_KAUFEN = 'real_estate_type_kaufen';
export const PRICEDEV_INFO_ICON = 'pricedev_info_icon';
export const PRICEDEV_RLE_OVERLAY_BTN = 'pricedev_rle_overlay_btn';
export const RLE_BANNER = 'rle_banner_click';
export const RLE_BANNER_NEW = 'rle_banner_click_new';
export const RLE_BANNER_OLD = 'rle_banner_click_old';
export const DASHBOARD_BUTTON_PRICE_DEV = 'dashboard_button_price_dev';
export const INTERACTIVE_MAP_CTA = 'interactive_map_cta';
export const STATIC_MAP_CTA = 'static_map_cta';
export const DASHBOARD_MAP_WIDGET = 'dashboard_map_widget';
export const EXPAND_SEO_LINKS = 'expand_seo_links';
export const EXPLORE_SEO_LINKS = 'explore_seo_links';
export const TRACK_MY_PROPERTY_CLICK_V2 = 'preisentwicklung';
export const FUTURE_PRICE_TREND_LINK_MY_PROPERTY = 'pricedev_activate_future_price_trend';
export const REAL_ESTATE_PREVIEW_CLICK = 'select_new_mktg_focus';
export const REAL_ESTATE_FORM_EDIT_ZIPCODE_COMING_SOON = 'MyProperty_comingsoon_overlay_starteditzipcode';
export const REAL_ESTATE_FORM_EDIT_CITY_COMING_SOON = 'MyProperty_comingsoon_overlay_starteditcity';
export const REAL_ESTATE_FORM_EDIT_STREET_COMING_SOON = 'MyProperty_comingsoon_overlay_starteditstreet';
export const REAL_ESTATE_FORM_EDIT_HOUSE_NUMBER_COMING_SOON = 'MyProperty_comingsoon_overlay_startedithousenumber';
export const REAL_ESTATE_FORM_EDIT_SPECS_COMING_SOON = 'MyProperty_comingsoon_overlay_starteditspecs';
export const REAL_ESTATE_FORM_EDIT_CONSTRUCTION_YEAR_COMING_SOON =
  'MyProperty_comingsoon_overlay_starteditconstructionyear';
export const REAL_ESTATE_FORM_EDIT_MODERNIZATION_DATE_COMING_SOON =
  'MyProperty_comingsoon_overlay_starteditmodernizationdate';
export const REAL_ESTATE_FORM_EDIT_QUALITY_OF_EQUIPMENT_COMING_SOON =
  'MyProperty_comingsoon_overlay_starteditqualityofequipment';
export const REAL_ESTATE_FORM_EDIT_DESIRED_PRICE_COMING_SOON = 'MyProperty_comingsoon_overlay_starteditdesiredprice';

export const REAL_ESTATE_FORM_EDIT_VALIDATION_ERROR_COMING_SOON =
  'MyProperty_comingsoon-val-error-fieldvalidationerror';
export const REAL_ESTATE_FORM_EDIT_GIS_VALIDATION_ERROR_COMING_SOON =
  'MyProperty_comingsoon-val-error-gisvalidationerror';
export const REAL_ESTATE_FORM_EDIT_OMA_VALIDATION_ERROR_COMING_SOON =
  'MyProperty_comingsoon-val-error-omavalidationerror';
export const REAL_ESTATE_FORM_EDIT_SUBMIT_COMING_SOON = 'MyProperty_comingsoon-submit';

export const REAL_ESTATE_FORM_EDIT_CITY = 'MyProperty-overlay-starteditcity';
export const REAL_ESTATE_FORM_EDIT_STREET = 'MyProperty-overlay-starteditstreet';
export const REAL_ESTATE_FORM_EDIT_SPECS = 'MyProperty-overlay-starteditspecs';
export const REAL_ESTATE_FORM_EDIT_FLOOR = 'MyProperty-overlay-starteditfloor';
export const REAL_ESTATE_FORM_EDIT_CONSTRUCTION_YEAR = 'MyProperty-overlay-starteditconstructionyear';
export const REAL_ESTATE_FORM_EDIT_MODERNIZATION_YEAR = 'MyProperty-overlay-starteditmodernizationdate';
export const REAL_ESTATE_FORM_EDIT_EQUIPMENT_QUALITY = 'MyProperty-overlay-starteditqualityofequipment';
export const REAL_ESTATE_FORM_EDIT_CONDITION = 'MyProperty-overlay-starteditconditionofproperty';
export const REAL_ESTATE_FORM_EDIT_PARKING_SPACE_TYPE = 'MyProperty-overlay-starteditselectionofgarage';
export const REAL_ESTATE_FORM_EDIT_EQUIPMENT = 'MyProperty-overlay-starteditequipment';

export const REAL_ESTATE_FORM_EDIT_VALIDATION_ERROR = 'MyProperty-overlay-val-error-fieldvalidationerror';
export const REAL_ESTATE_FORM_EDIT_GIS_VALIDATION_ERROR = 'MyProperty-overlay-val-error-gisvalidationerror';
export const REAL_ESTATE_FORM_EDIT_OMA_VALIDATION_ERROR = 'MyProperty-overlay-val-error-omavalidationerror';
export const REAL_ESTATE_FORM_EDIT_SUBMIT = 'MyProperty-overlay-submit';

export const CLAIM_PROPERTY = 'claim-property';
export const MY_PROPERTY_HUB_LINK = 'MyProperty-link_HUB';
export const MY_PROPERTY_IBW_LINK = 'MyProperty-link_IBW';
export const MY_PROPERTY_IBW_LINK_NO_PDF = 'MyProperty_btn_IBW_w/_PDF';
export const MY_PROPERTY_IBW_LINK_WITH_PDF = 'MyProperty_btn_PDF_download';
export const MY_PROPERTY_BTN_EDIT = 'MyProperty-btn_edit';
export const MY_PROPERTY_BTN_REDIRECT_SCOUTMANAGER = 'MyProperty_edit_more_functions';
export const MY_PROPERTY_BTN_PPA = 'MyProperty_btn_PPA';
export const MY_PROPERTY_DROPDOWN_BOX_SELECT = 'MyProperty_dropdown_select_newproperty';
export const MY_PROPERTY_COMINGSOON_LEARNMORE = 'MyProperty_comingsoon_learnmore';
export const MY_PROPERTY_COMINGSOON_OPEN = 'MyProperty_comingsoon_open';
export const MY_PROPERTY_COMINGSOON_START_EDIT_DESIRED_PRICE = 'MyProperty_comingsoon_starteditdesiredprice';
export const MY_PROPERTY_COMINGSOON_EDIT = 'MyProperty_comingsoon_edit';
export const MY_PROPERTY_COMINGSOON_DEACTIVATE_REQUEST = 'MyProperty_comingsoon_deactivate_request';
export const MY_PROPERTY_COMINGSOON_DEACTIVATE_CONFIRM = 'MyProperty_comingsoon_deactivate_confirm';
export const DL_EXPOSE_LINK = 'interactive_map_listings_details_clickout_expose';
export const DL_PRICE_TREND_LINK = 'interactive_map_listings_details_clickthrough_price_trend';
export const DL_PRICE_VALUATION_LINK = 'interactive_map_listings_details_clickthrough_valuation';
export const DL_MY_PROPERTY_SAVE = 'interactive_map_listings_details_clickthrough_myproperty';
export const CONTACT_FORM_TOOLTIP_MYPROPERTY_LINK = 'interactive_map_CSL_tooltip_myproperty';
export const CONTACT_FORM_TOOLTIP_CONTACT_OWNER_BUTTON = 'interactive_map_CSL_tooltip_contact_owner';
export const DL_CONTACT_REALTOR_LINK = 'interactive_map_listings_details_clickout_realtor_contact';
export const EXPOSE_LINK = 'interactive_map_listings_bar_expose_click';
export const EXPOSE_IMAGE_LINK = 'interactive_map_listings_details_photo_clickout_expose';
export const EXPOSE_PROPERTY_LINK = 'interactive_map_popout_mp_link';
export const INTERACTIVE_MAP_UPDATE_RESULT_CHECK = 'interactive_map_listings_bar_automatically_update_results_check';
export const INTERACTIVE_MAP_UPDATE_RESULT_UNCHECK =
  'interactive_map_listings_bar_automatically_update_results_uncheck';
export const INTERACTIVE_MAP_LISTINGS_BAR_UPDATE_RESULTS = 'interactive_map_listings_bar_update_results';
export const NAVIGATION_MY_PROPERTY_VIEW = 'navigation_my_property_view';
export const INTERACTIVE_MAP_LISTINGS_BAR_INCREASE_SEARCH_AREA = 'interactive_map_listings_bar_increase_search_area';
export const INTERACTIVE_MAP_LISTINGS_DETAILS_CLICKTHROUGH_VALUATION =
  'interactive_map_listings_details_clickthrough_valuation_ct_lf';
export const MYPROPERTY_COMINGSOON_SUBMIT = 'MyProperty_comingsoon_submit';
export const INTERACTIVE_MAP_CSL_LISTINGS_DETAILS_CONTACT_OWNER = 'interactive_map_CSL_listings_details_contact_owner';
export const INTERACTIVE_MAP_CSL_CONTACT_FORM_SUBMIT = 'interactive_map_CSL_contact_form_submit';
export const INTERACTIVE_MAP_CSL_REPORT_FRAUD = 'interactive_map_CSL_report_fraud';
export const RLE_BANNER_CLICK_COMPLETE_DATA = 'rle_banner_click_complete_data';
